/**
 * Copyright 2024-2025 Wingify Software Pvt. Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let NetworkClient;

if ((typeof process.env as any) === 'undefined') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  NetworkClient = require('./client/NetworkBrowserClient').NetworkBrowserClient;
} else {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  NetworkClient = require('./client/NetworkClient').NetworkClient;
}

export { NetworkClient };
export { NetworkClientInterface } from './client/NetworkClientInterface';
export { NetworkManager } from './manager/NetworkManager';
export { GlobalRequestModel } from './models/GlobalRequestModel';
export { RequestModel } from './models/RequestModel';
export { ResponseModel } from './models/ResponseModel';
